import { gql, TypedDocumentNode } from '@common/hooks';

type WorksListDueDateMutationVariables = {
  worksListId: string;
  input: {
    deadlineDetails: string;
    deadlineDueDate: string;
  };
};

type WorksListDueDateMutationResponse = {
  error?: object;
  worksList: {
    id: string;
    deadlineDetails: string;
    deadlintDueDate: string;
  };
};

export const WorksListDueDateMutation: TypedDocumentNode<
  WorksListDueDateMutationResponse,
  WorksListDueDateMutationVariables
> = gql`
  mutation WorksListDueDateMutation(
    $worksListId: ID!
    $input: UpdateWorksListDueDateInput!
  ) {
    updateWorksListDueDate(worksListId: $worksListId, input: $input) {
      worksList {
        id
        deadlineDetails
        deadlineDueDate
      }
    }
  }
`;
